import { Box, Grid, Skeleton, Typography } from "@mui/material";
import ListingDetailsInfoOwner from "components/listing-details-owner";
import DetailsImageGridOwner from "components/listing-details-owner/image-grid";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { searchListingDetailsOwner } from "slices/searchListingReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";

const ListingDetailsOwner = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const { loadingDetails }: any = useAppSelector(
    (state) => state.searchListingReducer
  );
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(searchListingDetailsOwner({ id: params.id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return (
    <Box sx={{ mb: "30px" }}>
      <Box
        sx={{
          display: {
            md: "flex",
            lg: "flex",
            xl: "flex",
            sm: "flex",
            xs: "flex",
          },
          px: "1%",
          py: "20px",
          borderBottom: "1px solid #F4F4F4",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            flex: 2,
          }}
        >
          <img
            src="/assets/img/icons/arrow_left.svg"
            alt=""
            width="24px"
            height="24px"
            onClick={() => navigate(-1)}
          />
          <Typography
            sx={{
              color: "#323232",
              fontWeight: 600,
              fontSize: "24px",
              lineHeight: "35px",
            }}
          >
            Listing Details
          </Typography>
        </Box>
      </Box>
      <Grid container spacing={3}>
        <Grid item md={7} lg={7} xl={7} sm={12} xs={12}>
          {!loadingDetails && (
            <Box>
              <DetailsImageGridOwner />
            </Box>
          )}
          {loadingDetails && (
            <Box
              sx={{
                display: {
                  md: "block",
                  lg: "block",
                  xl: "block",
                  sm: "none",
                  xs: "none",
                },
                pl: "4%",
                py: "20px",
              }}
            >
              <Grid container spacing={2}>
                <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      height: "350px",
                      width: "100%",
                      borderRadius: "10px",
                    }}
                  />
                </Grid>
                <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      height: "350px",
                      width: "100%",
                      borderRadius: "10px",
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>
        <Grid item md={5} lg={5} xl={5} sm={12} xs={12}>
          <Box>
            <ListingDetailsInfoOwner />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ListingDetailsOwner;
